import { createApp } from 'vue';
const lists = document.querySelectorAll('.webien-searchable-list-app');

lists.forEach((list) => {

    let $app = createApp({
        name: "searchableList-" + list.dataset.unique,
        data() {
            return {
                appReady: false,
                settings: [],
                items: [],
                templates: [],
                showAllItems: false,
                ready: false,
                order: 'none',
                collapsed: false,
                searchQuery: '',
                searchPlaceholder: 'Sök butik',
                selectedTaxFilter: 'all'
            }
        },
        mixins: [

        ],
        computed: {
            mainList() {

                if(!this.settings.sections || this.settings.sections.length === 0) return ([]);


                let list = {
                    visible: [],
                    more: []
                };

                let items = this.items.slice();

                // Apply search
                if (this.searchQuery && this.searchQuery.trim() !== '') {
                    items = items.filter((item) => this.matchesSearch(item, this.searchQuery));
                }

                // Apply order
                items = items.sort((a, b) => {
                    let titleA = a.title || '';
                    let titleB = b.title || '';

                    if (this.order === 'name-DESC') {
                        return titleB.localeCompare(titleA, 'sv');
                    }

                    return titleA.localeCompare(titleB, 'sv');
                });

                // Filter by taxonomies
                if(this.selectedTaxFilter && this.searchQuery.length < 1){
                    if(this.selectedTaxFilter !== 'all'){
                        items = items.filter(item => {
                            return item.terms.includes(this.selectedTaxFilter);
                        });
                    }

                }



                // Insert sections as stated in settings
                this.settings.sections.forEach((section) => {
                    if(section.type === 'posts'){
                        // Slice items from product list and insert to items
                        let count = section.item_count || 4;
                        if(count === -1) count = items.length;
                        let sliced = items.splice(0, count);
                        list.visible = list.visible.concat(sliced);
                    }
                    if(section.type === 'template'){
                        // Find template by id
                        let template = this.templates.find(t => t.id === section.template);
                        if(template){
                            list.visible.push(template);
                        }
                    }
                });


                if(this.showAllItems){
                    // If showing all, add remaining items to visible
                    list.visible = list.visible.concat(items);
                    items = [];
                } else {
                    // If not showing all, add remaining items to more
                    list.more = items;
                    items = [];
                }

                this.appReady = true;

                return list;

            },
            mainListCharacteristics() {
                let items = [];
                let currentGroup = null;

                this.mainList.visible.forEach((item) => {
                    if (item.type !== 'post') {
                        items.push(item);
                        return;
                    }

                    let key = this.getItemGroupKey(item);

                    if (key !== currentGroup) {
                        currentGroup = key;
                        items.push({
                            id: 'character-' + key,
                            type: 'character',
                            character: key,
                        });
                    }

                    items.push(item);
                });

                return items;
            }

        },
        watch: {

        },
        methods: {
            refresh() {
                let $vue = this;
                $vue.items = window['searchableList_' + list.dataset.unique];
            },
            updateOrder(newOrder) {
                this.order = newOrder;
            },
            showAll() {
                this.showAllItems = true;
            },
            search() {
                this.showAllItems = false;
            },
            matchesSearch(item, query) {
                if (!item || item.type !== 'post') {
                    return true;
                }

                let normalizedQuery = query.toLowerCase().trim();

                if (!normalizedQuery) {
                    return true;
                }

                let haystack = (item.title || '').toLowerCase();

                return haystack.includes(normalizedQuery);
            },
            getItemGroupKey(item) {
                let label = (item.title || '').trim();

                if (!label) {
                    return '#';
                }

                let firstCharacter = label.charAt(0).toUpperCase();

                if (!/^[A-ZÅÄÖ]$/i.test(firstCharacter)) {
                    return '#';
                }

                return firstCharacter;
            },

        },
        mounted: function () {
            let $vue = this;

            this.items = window['searchableList_' + list.dataset.unique];
            this.settings = window['widgetSettings_' + list.dataset.unique];
            this.templates = window['templateList_' + list.dataset.unique];
            this.ready = true;


            window.addEventListener(
                "refreshPostList",
                (e) => {
                    $vue.refresh();
                },
                false,
            );

            // If term filter, set active term
            if(Array.isArray(this.settings.tax_filter)){
                // Get the term that has flag active in tax_filter and set it as selectedTaxFilter
                let activeTerm = this.settings.tax_filter.find(term => term.active);
                if(activeTerm){
                    this.selectedTaxFilter = activeTerm.id;
                } else {
                    this.selectedTaxFilter = 'all';
                }
            }



        },
        created() {

        },
        components: {
        },
    });

    // Mount app to DOM
    if(document.getElementById('searchableList-' + list.dataset.unique)){
        $app.mount('#searchableList-' + list.dataset.unique);
    }

});
